import { Subject } from 'rxjs';
/** Fasta and Helm */
export class BioFilterProps {
    constructor(substructure, 
    /** Pass false from an inheritors constructor, at the end set true. */ readOnly = true, logger) {
        this.substructure = substructure;
        this.readOnly = readOnly;
        this.logger = logger;
        return new Proxy(this, {
            set: (target, key, value) => {
                this.logger?.debug(`BioFilterProps.set ${key.toString()}( '${value}' )`);
                if (this.readOnly)
                    throw new Error('Properties are immutable.');
                target[key] = value;
                return true;
            }
        });
    }
}
/** Encapsulates input controls handling */
export class BioFilterBase {
    constructor() {
        this.onChanged = new Subject();
        this._props = null;
        this._propsChanging = false;
    }
    get props() {
        if (!this._props)
            this._props = this.emptyProps;
        return this._props;
    }
    ;
    set props(value) {
        this._propsChanging = true;
        try {
            this._props = value;
            this.applyProps();
            this.onChanged.next();
        }
        finally {
            this._propsChanging = false;
        }
    }
    ;
    saveProps() {
        const propsObj = {};
        for (const [key, value] of Object.entries(this.props)) {
            if (key !== '_onChanged' && key !== 'logger') {
                // @ts-ignore
                propsObj[key] = this.props[key];
            }
        }
        return propsObj;
    }
    async detach() { }
    get filterSummary() { return this.props.substructure; }
    ;
    get isFiltering() { return this.props.substructure !== ''; }
    resetFilter() {
        this.props = this.emptyProps;
        this.onChanged.next();
    }
}
//# sourceMappingURL=bio-substructure-filter-types.js.map